import { render, staticRenderFns } from "./taskManager.vue?vue&type=template&id=56f134f0&scoped=true&"
import script from "./taskManager.vue?vue&type=script&lang=js&"
export * from "./taskManager.vue?vue&type=script&lang=js&"
import style0 from "./taskManager.vue?vue&type=style&index=0&id=56f134f0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f134f0",
  null
  
)

export default component.exports